import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { platformFeatures } from '../../config/platformFeatures';
import { ALL } from '../../../../config/constants';
import { useTranslate } from '@tolgee/react';
import { Button } from 'react-bootstrap';

import CreatorTitle from '../commonElements/creatorTitle';
import CreatorCard from '../commonElements/creatorCard';
import { VIDEO } from '../../config/constants';
import toast from 'react-hot-toast';
import { setModalUiContent } from '../../../../redux/slices/lomavisCreator/lomavisCreator';
import { dispatch } from '../../../../redux/store';
import { lomavisCreatorRootState } from '../../../../pages/lomavisCreator';

export default function OverlayArea() {
  const {
    postData,
    lomavisCreatorConfig,
    postTypeSelected,
    cropsCache,
    platformEnabled,
    overlay_enabled,
    overlayData,
    brandData,
    cloudUuid,
    ui: { previewMode }
  } = useSelector((state: lomavisCreatorRootState) => state.lomavisCreator);

  const { t } = useTranslate();

  return (
    <CreatorCard>
      <CreatorTitle title="overlayTitle" />
      <div>
        <div>
          {/* Show message if no overlays exist */}
          {overlayData?.length === 0 && (
            <p className="text-muted fw-bold w-100 text-center">
              {t('lomavisCreator.overlay.nonAdded')}
            </p>
          )}

          {/* Render overlay images */}
          {overlayData?.length > 0 && (
            <div className="d-flex flex-row flex-wrap gap-2">
              {overlayData.map((overlay, index) => (
                <div
                  key={index}
                  className="bg-white rounded d-flex align-items-center justify-content-center img-thumbnail"
                  style={{
                    width: '50px',
                    height: '50px',
                    overflow: 'hidden'
                  }}
                >
                  {/* @ts-ignore */}
                  <img
                    src={overlay?.overlay?.url}
                    alt={`Overlay ${index}`}
                    style={{
                      width: '100%',
                      height: '100%',
                      objectFit: 'cover'
                    }}
                  />
                </div>
              ))}
            </div>
          )}
        </div>

        <div className={'d-flex justify-content-end'}>
          <div>
            <Button
              className="p-1 btn-sm btn-secondary"
              onClick={() => {
                console.log('postData', overlayData);

                if (
                  !postData[ALL].media ||
                  postData[ALL].media.length === 0 ||
                  (postData[ALL].media?.find(
                    (item) => item?.media_type === VIDEO
                  ) &&
                    false)
                ) {
                  toast.error(`${t('errors.overlay.images_only')}`, {
                    duration: 4000,
                    position: 'top-right'
                  });
                  return;
                } else {
                  dispatch(
                    setModalUiContent({
                      modal: 'brandOverlay',
                      attribute: 'toggle',
                      value: true
                    })
                  );
                }
              }}
            >
              {t('lomavisCreator.overlays.addEditOverlay')}
            </Button>
          </div>
        </div>
      </div>
    </CreatorCard>
  );
}
